export const MillionContractAddress = process.env.REACT_APP_MODE=="TEST"?'0x5F2F2f2CABc89e611D1c7C08451f831dad07a342':'0x9867cc2419fb317e986a648e02cf7c35aa87a336';
